import { THEME_FONTS } from '../../shared/index.ts';
import { PREFIX } from '../../shared/utils/index.ts';

export function getFont(font: keyof THEME_FONTS) {
  return `var(${PREFIX.FONT}${font})`;
}
